import React from 'react';
import './carousel.css';

const Carousel = ({ bannerData, name }) => {
  if (!bannerData || bannerData.length === 0) return null;

  return (
    <div id={name} className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        {bannerData.map((item, index) => (
          <div 
            key={index} 
            className={`carousel-item ${index === 0 ? "active" : ""}`}
          >
            {/* Si tiene URL, es un enlace; si no, solo muestra la imagen */}
            {item.url ? (
              <a href={item.url} target="_blank" rel="noopener noreferrer">
                <ImagenResponsive item={item} index={index} />
              </a>
            ) : (
              <ImagenResponsive item={item} index={index} />
            )}
          </div>
        ))}
      </div>
      
      <button className="carousel-control-prev" type="button" data-bs-target={`#${name}`} data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target={`#${name}`} data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

// Componente interno para manejar la imagen responsive
const ImagenResponsive = ({ item, index }) => {
  return (
    <picture>
      {/* Imagen para móvil (si existe imagenMobile) */}
      {item.imagenMobile && (
        <source 
          media="(max-width: 768px)" 
          srcSet={item.imagenMobile} 
        />
      )}
      {/* Imagen por defecto (desktop) */}
      <img 
        src={item.imagen} 
        className="d-block w-100 img-carousel" 
        alt={`Slide ${index + 1}`} 
        loading={index === 0 ? "eager" : "lazy"}
      />
    </picture>
  );
};

export default Carousel;
